"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'home_custom_nav',
  cname: '自定义导航',
  icon: 't-icon-zujian-daohangzu',
  configName: 'c_home_custom_nav',
  type: 0,
  defaultName: 'customNav',
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), {}, {
    boxStyle: function boxStyle() {
      return [{
        'border-radius': (this.configObj.bgStyle.val || 0) + 'px'
      }, {
        background: this.configObj.bgColor.color[0].item.toUpperCase() === '#FFFFFF' && this.configObj.bgColor.color[1].item.toUpperCase() === '#FFFFFF' ? '' : 'linear-gradient(' + this.configObj.bgColor.color[0].item + ', ' + this.configObj.bgColor.color[1].item + ')'
      }, {
        margin: this.configObj.mbConfig.val + 'px ' + this.configObj.lrConfig.val + 'px 0'
      }, {
        padding: this.configObj.upConfig.val + 'px 0 ' + this.configObj.downConfig.val + 'px'
      }];
    },
    isMany: function isMany() {
      return this.configObj.tabConfig ? this.configObj.tabConfig.tabVal : 1;
    },
    gridStyle: function gridStyle() {
      var col = 4;
      if (this.configObj.number) {
        if (this.configObj.number.tabVal === 0) col = 3;else if (this.configObj.number.tabVal === 1) col = 4;else col = 5;
      }
      return {
        'grid-template-columns': 'repeat(' + col + ', 1fr)',
        'grid-row-gap': (this.configObj.contentConfig.val || 10) + 'px'
      };
    },
    iconBoxStyle: function iconBoxStyle() {
      return {
        'border-radius': (this.configObj.contentStyle.val || 0) + 'px'
      };
    },
    labelStyle: function labelStyle() {
      return {
        color: this.configObj.titleColor.color[0].item
      };
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler() {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        name: 'customNav',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '自定义导航'
        },
        activeTab: 0,
        tabConfig: {
          title: '展示样式',
          tabTitle: '展示设置',
          tabVal: 1,
          isShow: 1,
          list: [{
            val: '单行展示',
            icon: 'icon-yangshiyi'
          }, {
            val: '多行展示',
            icon: 'icon-yangshier'
          }]
        },
        rowsNum: {
          title: '显示行数',
          name: 'rowsNum',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '2行',
            icon: 'icon-daohang-2hang'
          }, {
            val: '3行',
            icon: 'icon-daohang-3hang'
          }, {
            val: '4行',
            icon: 'icon-daohang-4hang'
          }]
        },
        number: {
          title: '显示个数',
          name: 'number',
          tabVal: 1,
          isShow: 1,
          list: [{
            val: '3个',
            icon: 'icon-daohang-3ge'
          }, {
            val: '4个',
            icon: 'icon-daohang-4ge'
          }, {
            val: '5个',
            icon: 'icon-daohang-5ge'
          }]
        },
        tabList: {
          tabTitle: 'Tab设置',
          title: '导航分类',
          list: [{
            value: '线上商城',
            menuList: {
              0: {
                img: '',
                info: [{
                  title: '标题',
                  value: '品牌馆',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              1: {
                img: '',
                info: [{
                  title: '标题',
                  value: '限时秒杀',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              2: {
                img: '',
                info: [{
                  title: '标题',
                  value: '美妆个护',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              3: {
                img: '',
                info: [{
                  title: '标题',
                  value: '食品酒水',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              4: {
                img: '',
                info: [{
                  title: '标题',
                  value: '家居家电',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              5: {
                img: '',
                info: [{
                  title: '标题',
                  value: '服饰鞋包',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              6: {
                img: '',
                info: [{
                  title: '标题',
                  value: '全部分类',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              7: {
                img: '',
                info: [{
                  title: '标题',
                  value: '我的订单',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              }
            }
          }, {
            value: '本地生活',
            menuList: {
              0: {
                img: '',
                info: [{
                  title: '标题',
                  value: '美食外卖',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              1: {
                img: '',
                info: [{
                  title: '标题',
                  value: '到店餐饮',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              2: {
                img: '',
                info: [{
                  title: '标题',
                  value: '休闲娱乐',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              3: {
                img: '',
                info: [{
                  title: '标题',
                  value: '酒店住宿',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              4: {
                img: '',
                info: [{
                  title: '标题',
                  value: '生活服务',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              5: {
                img: '',
                info: [{
                  title: '标题',
                  value: '丽人美发',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              6: {
                img: '',
                info: [{
                  title: '标题',
                  value: '全部分类',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              },
              7: {
                img: '',
                info: [{
                  title: '标题',
                  value: '我的订单',
                  tips: '选填，不超过4个字',
                  max: 4
                }],
                status: true
              }
            }
          }]
        },
        bgColor: {
          tabTitle: '颜色设置',
          title: '背景颜色',
          name: 'bgColor',
          color: [{
            item: '#fff'
          }, {
            item: '#fff'
          }],
          default: [{
            item: '#fff'
          }, {
            item: '#fff'
          }]
        },
        titleColor: {
          title: '文字颜色',
          name: 'titleColor',
          color: [{
            item: '#282828'
          }],
          default: [{
            item: '#282828'
          }]
        },
        tabActiveColor: {
          title: 'Tab激活颜色',
          name: 'tabActiveColor',
          color: [{
            item: '#FF4D4F'
          }],
          default: [{
            item: '#FF4D4F'
          }]
        },
        tabInactiveColor: {
          title: 'Tab未激活颜色',
          name: 'tabInactiveColor',
          color: [{
            item: '#333333'
          }],
          default: [{
            item: '#333333'
          }]
        },
        bgStyle: {
          tabTitle: '圆角设置',
          title: '背景圆角',
          name: 'bgStyle',
          val: 12,
          min: 0,
          max: 30
        },
        contentStyle: {
          title: '图标圆角',
          name: 'contentStyle',
          val: 12,
          min: 0,
          max: 30
        },
        contentConfig: {
          title: '内容间距',
          val: 10,
          min: 0,
          max: 30
        },
        upConfig: {
          tabTitle: '边距设置',
          title: '上边距',
          val: 10,
          min: 0,
          max: 100
        },
        downConfig: {
          title: '下边距',
          val: 10,
          min: 0
        },
        lrConfig: {
          title: '左右边距',
          val: 12,
          min: 0,
          max: 25
        },
        mbConfig: {
          title: '页面间距',
          val: 10,
          min: 0
        }
      },
      configObj: null,
      activeTab: 0,
      showList: [],
      pageData: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    this.$nextTick(function () {
      if (self.num) {
        self.pageData = self.$store.state.mobildConfig.defaultArray[self.num];
        self.setConfig(self.pageData);
      }
    });
  },
  methods: {
    objToArr: function objToArr(data) {
      var keys = Object.keys(data);
      var result = [];
      for (var i = 0; i < keys.length; i++) {
        result.push(data[keys[i]]);
      }
      return result;
    },
    getTabStyle: function getTabStyle(tIndex) {
      var isActive = this.activeTab === tIndex;
      if (isActive) {
        return {
          background: this.configObj.tabActiveColor.color[0].item,
          color: '#fff'
        };
      }
      return {
        background: 'transparent',
        color: this.configObj.tabInactiveColor.color[0].item
      };
    },
    switchTab: function switchTab(index) {
      this.activeTab = index;
      this.configObj.activeTab = index;
    },
    setConfig: function setConfig(data) {
      if (!data) return;
      this.configObj = data;
      this.activeTab = data.activeTab || 0;
      this.updateShowList();
    },
    updateShowList: function updateShowList() {
      if (!this.configObj || !this.configObj.tabList || !this.configObj.tabList.list) return;
      var tabData = this.configObj.tabList.list[this.activeTab];
      if (!tabData || !tabData.menuList) {
        this.showList = [];
        return;
      }
      var list = this.objToArr(tabData.menuList);
      var isMany = this.configObj.tabConfig ? this.configObj.tabConfig.tabVal : 1;
      if (isMany === 0) {
        this.showList = list.slice(0, 5);
      } else {
        var rowsNum = this.configObj.rowsNum ? this.configObj.rowsNum.tabVal : 0;
        var number = this.configObj.number ? this.configObj.number.tabVal : 1;
        var cols = number === 0 ? 3 : number === 1 ? 4 : 5;
        var rows = rowsNum === 0 ? 2 : rowsNum === 1 ? 3 : 4;
        this.showList = list.slice(0, cols * rows);
      }
    }
  }
};